export enum ConnectorPropertyColumn {
  TYPE = 'type',
  PHOTO = 'photo',
  NAME = 'name',
  ADDRESS = 'address',
  STATUS = 'status',
  ACTIONS = 'actions'
}
